import { render, staticRenderFns } from "./ProblemTrend.vue?vue&type=template&id=23b20a01&scoped=true"
import script from "./ProblemTrend.vue?vue&type=script&lang=js"
export * from "./ProblemTrend.vue?vue&type=script&lang=js"
import style0 from "./ProblemTrend.vue?vue&type=style&index=0&id=23b20a01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b20a01",
  null
  
)

export default component.exports